export const IdentityInjectionToken = Symbol('Identity');
/**
 * Identity represents a digital identity, specified by cryptographic keys,
 * and capable of signing. You can configure new Identities in IdentityMapping.ts.
 */
export class Identity {
}
//# sourceMappingURL=Identity.js.map